import {
  VerifyData,
  VerifyOtherpeopleData,
  VerifyPaperData,
} from '@/types/verify';
import { requestGet } from '@/services/request';
// 通过身份证查询别人的考试情况
export async function apiVerifyOtherByIdentity(params: {
  realName: string; // 真实姓名
  identity: string; // 身份证号
  certId: string; // 认证id
}): Promise<{
  success: Boolean;
  code: number;
  msg: string;
  data: VerifyOtherpeopleData;
}> {
  return requestGet('/v1/cert/search/identity', params);
}

// 从查询别人的考试情况
export async function apiVerifyOther(params: {
  realName: string; // 真实姓名
  certNo: string; // 身份证号
}): Promise<{
  success: Boolean;
  code: number;
  msg: string;
  data: VerifyOtherpeopleData;
}> {
  return requestGet('/v1/cert/search/certno', params);
}
// 查询本人的考试情况
export async function apiVerifyMyself(params: {
  page: number;
  pagesize?: number;
  status?: '1' | '2';
  startTime?: number;
  endTime?: number;
}): Promise<{
  success: Boolean;
  code: number;
  msg: string;
  data: {
    total: number;
    list: VerifyData[];
  };
}> {
  return requestGet('/v1/cert/search/list', params);
}
// 获取考卷列表
export async function getExamPaper(params: { paperId: string }): Promise<{
  code: number;
  data: VerifyPaperData[];
}> {
  return requestGet('/v1/cert/get/papers', params);
}
